import { CustomColumn } from '../../../types/customColumn';

export const debitNoteProductColumns: CustomColumn<any>[] = [
  {
    Header: '#',
    id: 'rowIndex',
    accessor: 'productId',
    customCell: (cell: any) => {
      const index = cell.row.index;
      const { pageIndex = 0, pageSize = 10 } = cell.table?.state || {};
      return pageIndex * pageSize + index + 1;
    },
  },
  
  {
    Header: 'Producto',
    accessor: 'productName',
    customCell: ({ row }) => {
      const {
        productCode,
        productName,
        categoryName,
        type,
        serviceDescription,
      } = row.original;

      const isService = type === 'SERVICE';

      const typeLabel = {
        PRICE_INCREASE: 'AJUSTE DE PRECIO',
        NEW_PRODUCT: 'PRODUCTO NUEVO',
        SERVICE: 'SERVICIO',
      }[type];

      return (
        <div className="text-sm leading-6">
          <div className="text-gray-600 dark:text-gray-400 mb-1 text-xs">
            {typeLabel}
          </div>
          <div className="font-medium text-black dark:text-white">
            {isService ? serviceDescription : `(${productCode}) ${productName}`}
          </div>
          {!isService && (
            <div className="text-gray-600 dark:text-gray-400 mt-1 space-y-1 text-xs">
              <div>
                <strong>CATEGORÍA:</strong> {categoryName || '—'}
              </div>
            </div>
          )}
        </div>
      );
    },
  },
  {
    Header: 'Cantidad',
    accessor: 'quantity',
    customCell: ({ row }) => {
      const { quantity, unitCode, type, settledQuantity } = row.original;
      const showUnit = type === 'NEW_PRODUCT' || type === 'PRICE_INCREASE';

      return (
        <div className="text-sm leading-6">
          <div>
            {Number(quantity).toFixed(2)} {showUnit ? unitCode || '' : ''}
          </div>

          {settledQuantity !== undefined && (
            <div className="text-gray-500 mt-1 text-xs">
              <strong>Asentado:</strong> {Number(settledQuantity).toFixed(2)}{' '}
              {showUnit ? unitCode || '' : ''}
            </div>
          )}
        </div>
      );
    },
  },
  {
    Header: 'Costo Unitario',
    accessor: 'unitCost',
    customCell: ({ value }) => (
      <div className="text-sm leading-6">${Number(value).toFixed(2)}</div>
    ),
  },
  {
    Header: 'IVA Total',
    accessor: 'ivaAmount',
    customCell: ({ value }) => (
      <div className="text-sm leading-6">${Number(value).toFixed(2)}</div>
    ),
  },
  {
    Header: 'Distribución',
    accessor: 'distributionPercent',
    customCell: ({ row }) => {
      const { distributionPercent, purchaseReferenceCode } = row.original;

      return (
        <div className="text-sm leading-6">
          <div>{Number(distributionPercent || 0).toFixed(2)}%</div>
          {purchaseReferenceCode && (
            <div className="text-gray-600 dark:text-gray-400 mt-1 text-xs">
              CCF - {purchaseReferenceCode}
            </div>
          )}
        </div>
      );
    },
  },
  {
    Header: 'Total Costo',
    accessor: 'totalAmount',
    customCell: ({ value }) => (
      <div className="text-sm font-medium leading-6">
        ${Number(value).toFixed(2)}
      </div>
    ),
  },
];
